/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { View } from 'react-native';
import { pixelDimensions } from '../../config/utils';

const VideoPlayer = ({ url }) => (
  <>
    {url.indexOf('vimeo.com') >= 0 ? (
      <div>
        <iframe
          title="howitworks"
          src={`${url}&playsinline=0`}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture; "
          allowFullScreen
          style={{
            width: pixelDimensions(90), height: pixelDimensions(90),
          }}
        />
        <script src="https://player.vimeo.com/api/player.js" />
      </div>
    ) : (
      <View style={{ paddingVertical: pixelDimensions(20) }}>
        <video controls controlsList="nodownload" playsInline>
          <source src={url} type="video/mp4" />
          {' '}
        </video>
      </View>
    )}
  </>

);

export default VideoPlayer;
